import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "icon-wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "app-name" }
const _hoisted_5 = { class: "app-subtitle" }
const _hoisted_6 = { class: "action-col" }
const _hoisted_7 = {
  key: 0,
  class: "iap-text"
}

import { computed, ref } from 'vue';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';
import { getAndroidDownloadURL } from '@/api/common';
import AppStoreInstallSelectionPopup from './AppStoreInstallSelectionPopup.vue';
import AppStorePwaInstructionsPopup from './AppStorePwaInstructionsPopup.vue';
import AppStoreIosProfileInstructionsPopup from './AppStoreIosProfileInstructionsPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const { t } = useI18n();

const installPopup = ref<InstanceType<typeof AppStoreInstallSelectionPopup> | null>(null);
const pwaInstructionsPopup = ref<InstanceType<typeof AppStorePwaInstructionsPopup> | null>(null);
const iosProfileInstructionsPopup = ref<InstanceType<typeof AppStoreIosProfileInstructionsPopup> | null>(null);
const deferredPrompt = ref<Event | null>(null);
const canInstall = ref(false);

const isIosSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    || !!(window.navigator as Navigator & { standalone?: boolean }).standalone;
  return isIOS && isSafari && !isStandalone;
};

const isChromiumPwaSupported = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('chrome') || ua.includes('chromium') || ua.includes('edge');
};

const pwaSupported = computed(() => {
  if (isIosSafari()) {
    return true;
  }
  return canInstall.value
    && isChromiumPwaSupported()
    && !!deferredPrompt.value
    && 'prompt' in deferredPrompt.value;
});

const getApp = () => {
  installPopup.value?.open(pwaSupported.value);
};

const installPWA = () => {
  if (deferredPrompt.value && 'prompt' in deferredPrompt.value) {
    const promptEvent = deferredPrompt.value as Event & { prompt: () => void };
    promptEvent.prompt();
    deferredPrompt.value = null;
    return;
  }

  if (isIosSafari()) {
    pwaInstructionsPopup.value?.open();
  }
};

const normalizeDownloadUrl = (url: string) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `https://${url}`;
};

const openDownloadUrl = (downloadUrl: string) => {
  const url = normalizeDownloadUrl(downloadUrl);
  if (!url) {
    showToast(t('appStoreInstall.iosProfileFailed'));
    return;
  }

  if (isIosSafari()) {
    window.location.assign(url);
    return;
  }

  window.open(url, '_blank');
};

const installIosProfile = () => {
  getAndroidDownloadURL({ paramString: 'ios_download_url' }).then(res => {
    const downloadUrl = res.data?.ios_download_url || '';
    openDownloadUrl(downloadUrl);
  }).catch((err) => {
    console.log('ios profile install err: ', err);
    showToast(t('appStoreInstall.iosProfileFailed'));
  });
};

const onInstallSelect = (type: 'pwa' | 'iosProfile') => {
  if (type === 'pwa') {
    installPWA();
  } else {
    iosProfileInstructionsPopup.value?.open();
  }
};

window.addEventListener('beforeinstallprompt', (e: Event) => {
  e.preventDefault();
  deferredPrompt.value = e;
  canInstall.value = true;
});

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_van_row, {
      type: "flex",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "6" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _unref(appData).icon,
                alt: "",
                class: "app-icon"
              }, null, 8, _hoisted_3)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)('donwload.appName')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('donwload.title')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "6" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_van_button, {
                round: "",
                size: "small",
                color: "#007AFF",
                class: "get-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (getApp()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('appStore.action')), 1)
                ]),
                _: 1
              }),
              (_unref(appData).hasInAppPurchases)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)('appStore.inAppPurchases')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(AppStoreInstallSelectionPopup, {
      ref_key: "installPopup",
      ref: installPopup,
      onSelect: onInstallSelect
    }, null, 512),
    _createVNode(AppStorePwaInstructionsPopup, {
      ref_key: "pwaInstructionsPopup",
      ref: pwaInstructionsPopup
    }, null, 512),
    _createVNode(AppStoreIosProfileInstructionsPopup, {
      ref_key: "iosProfileInstructionsPopup",
      ref: iosProfileInstructionsPopup,
      onDownload: installIosProfile
    }, null, 512)
  ]))
}
}

})